<template>
    <div>
        <div v-show="menuState == 0">
            <div id="password-reset-wrapper">
                <div class="form-title-row">
                    <button type="button" @click="goBack" class="back-button" aria-label="Zurück zum Login">
                        <img :src="require('@/assets/dashboard/angle-left-solid-dark-grey.svg')" alt="" />
                    </button>
                    <h3>Passwort zurücksetzen</h3>
                </div>
                <form id="password-reset-request" @submit.prevent="sendPasswordLink">
                    <div class="form-column">
                        <div class="input-container">
                            <label for="forgot-kdnr">Kundennummer:</label>
                            <input v-model.trim="kdnr" type="text" id="forgot-kdnr" name="kdnr" required >
                        </div>
                        <div class="input-container">
                            <label for="forgot-email">E-Mail:</label>
                            <input v-model.trim="email" type="email" id="forgot-email" name="email" required >
                        </div>
                        <div class="actions">
                            <button :disabled="isSending" type="submit" class="btn">{{ isSending ? 'Senden…' : 'Link senden' }}</button>
                        </div>
                    </div>
                    <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                </form>
            </div>
        </div>
        <div class="password-send-successful-container" v-show="menuState == 1">
            <div>Wir haben Ihnen einen Link zum Zurücksetzen des Passworts an Ihre hinterlegte E-Mail-Adresse versendet.</div>
        </div>
    </div>
</template>

<script>
import api from "@/api/client";

export default {
    components: {
        
    },
    data() {
      return {
        menuState: 0,
        email: "",
        kdnr: "",
        isSending: false,
        errorMessage: "",
      }
    },
    methods: {
        goBack() {
            this.$parent.changeMenuState(0);
        },
        changeMenuState(menuState) { 
            this.menuState = menuState;
        },
        async sendPasswordLink() {
            this.errorMessage = '';
            this.isSending = true;
            try {
                await api.post('/api/shopusers/password/forgot', {
                    email: this.email,
                    kdnr: this.kdnr,
                });
                this.changeMenuState(1);
                setTimeout(this.goBack, 4000);
            } catch (err) {
                this.errorMessage = err?.response?.data?.message || 'Senden fehlgeschlagen. Bitte Eingaben prüfen.';
            } finally {
                this.isSending = false;
            }
        }
    },
  }

</script>

<style scoped src="@/styles/ForgotPassword.css">

</style>
